import React from 'react';

const DoesNotContainsToSymbol = () => {
	return (
		<>
			<div className="does-not-contains-to-symbol">&#8836;</div>
		</>
	);
};

export default DoesNotContainsToSymbol;
